import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dashboardStats: {
    totalSales: 0,
    totalRevenue: 0,
    totalCustomers: 0,
    totalOrders: 0,
  },
  salesOverview: [],
  recentOrders: [],
  topSellingProducts: [],
  loading: false,
  error: null,
  success: false,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    // Dashboard statistics
    getDashboardStatsStart(state) {
      state.loading = true;
      state.error = null;
    },
    getDashboardStatsSuccess(state, action) {
      state.loading = false;
      state.dashboardStats = action.payload;
      state.success = true;
    },
    getDashboardStatsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },

    // Sales overview
    getSalesOverviewStart(state) {
      state.loading = true;
      state.error = null;
    },
    getSalesOverviewSuccess(state, action) {
      state.loading = false;
      state.salesOverview = action.payload;
      state.success = true;
    },
    getSalesOverviewFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },

    // Recent orders
    getRecentOrdersStart(state) {
      state.loading = true;
      state.error = null;
    },
    getRecentOrdersSuccess(state, action) {
      state.loading = false;
      state.recentOrders = action.payload;
      state.success = true;
    },
    getRecentOrdersFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },

    // Top selling products
    getTopSellingProductsStart(state) {
      state.loading = true;
      state.error = null;
    },
    getTopSellingProductsSuccess(state, action) {
      state.loading = false;
      state.topSellingProducts = action.payload;
      state.success = true;
    },
    getTopSellingProductsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },

    // Reset state
    resetDashboardState(state) {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
});

export const {
  getDashboardStatsStart,
  getDashboardStatsSuccess,
  getDashboardStatsFailure,
  getSalesOverviewStart,
  getSalesOverviewSuccess,
  getSalesOverviewFailure,
  getRecentOrdersStart,
  getRecentOrdersSuccess,
  getRecentOrdersFailure,
  getTopSellingProductsStart,
  getTopSellingProductsSuccess,
  getTopSellingProductsFailure,
  resetDashboardState,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;